/* eslint import/prefer-default-export: 0 */
import moment from 'moment';
import 'moment-timezone';

export const getGBDateNow = () => {
    const GBOffset = moment().tz('Europe/London').utcOffset();
    const localOffset = GBOffset - moment().utcOffset();
    return moment().add(localOffset, 'm');
};



// WEBPACK FOOTER //
// ./src/js/helpers/dateHelper.js